import classNames from 'classnames'
import { Timeline } from '../types'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import Text from '@/stories/components/Common/NewText'

function Widget({
  bgTertiary = false,
  title,
  image,
  data,
  color,
  minwidth,
  isH3 = true,
}: {
  bgTertiary?: boolean
  minwidth?: string
  isH3?: boolean
  title?: string
  image?: {
    png?: string
  }
  color?: string
  data?: Timeline[]
}) {
  if (!data?.length) {
    return null
  }

  const jsx = (
    <div className="flex flex-col">
      <div className="flex-shrink-0">
        {image?.png && (
          <StencilCDNImage
            src={image.png}
            width={30}
            height={30}
            className="p-0"
          />
        )}
      </div>
      <Text appearance="subtitle2" addClassName="py-2">
        {title}
      </Text>
      <section>
        {data.map(({ day_time, summary }) => (
          <Text
            tag={isH3 ? 'h3' : undefined}
            addClassName="font-medium flex py-2"
            key={day_time}
          >
            <p className="w-[25%] font-semibold">{day_time}</p>
            <span className="w-[5%]">-</span>
            <p className=" w-7/10 font-normal">{summary}</p>
          </Text>
        ))}
      </section>
    </div>
  )

  return (
    <li
      className={classNames(
        'border-brand-tertiary-blue min-w-full rounded-xl border-2 bg-white p-4 lg:min-w-[47%]',
        {
          'bg-brand-tertiary-blue': bgTertiary,
        },
        minwidth,
      )}
      style={{
        backgroundColor: color,
        borderColor: color,
      }}
    >
      {jsx}
    </li>
  )
}

export default Widget
